import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const SupplierOrderReconciliationRoutes: Routes = [
  {
    path: "supplier-order-reconciliation",
    loadComponent: () =>
      import("./supplier-order-reconciliation/supplier-order-reconciliation.component").then(
        (m) => m.SupplierOrderReconciliationComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./supplier-batches-list/order-reconciliation-list.component").then(
            (m) => m.OrderReconciliationListComponent,
          ),
      },
    ],
  },
];
